import useAgentData from "@casino/legacy/client/hooks/useAgentData";
import Carousel from "@casino/legacy/client/shared/Carousel";
import CarouselPlaceholder from "@casino/legacy/client/shared/LazyLoad/Placeholder/CaroulselPlaceholder";
import SectionTitle from "../TournamentSection/SectionTitle";

type Placeholder = { enabled: boolean; width?: number; height?: number };
type Props = {
  items: (React.JSX.Element | null)[];
  placeholder?: Placeholder;
  totalCount?: number;
  status?: TournamentStatus;
  reelClassName?: string;
  isHomeTournaments?: boolean;
  onlyMine?: boolean;
};

const CardSize = {
  mobile: {
    width: 242,
    height: 412,
  },
  desktop: {
    width: 572,
    height: 394,
  },
};

const TournamentCarousel: FC<Props> = ({
  items,
  placeholder,
  status,
  totalCount,
  reelClassName,
  isHomeTournaments,
  onlyMine,
}) => {
  const { isMobile } = useAgentData();
  const size =
    (placeholder?.width ?? isMobile) ? CardSize.mobile : CardSize.desktop;
  if (placeholder?.enabled) {
    return <CarouselPlaceholder reelClassName={reelClassName} {...size} />;
  }

  return (
    <div className="grid gap-2">
      <SectionTitle
        status={status}
        totalCount={totalCount}
        isHomeTournaments={isHomeTournaments}
        onlyMine={onlyMine}
      />
      <div className="grid gap-2">
        <Carousel step={2} reelClassName={reelClassName} items={items} />
      </div>
    </div>
  );
};

export default TournamentCarousel;
